<i18n src="./resources/locales.json"></i18n>
<template>
  <v-dialog v-model="dialog" persistent :max-width="customStyles.maxWidth">
    <v-card color="surface lighten-1">
      <v-card-title class="header">
        {{ title }}
      </v-card-title>
      <v-divider></v-divider>
      <div>
        <div v-for="bp in availableBusinessProcesses" :key="bp.id" class="bp-list-item" @click="select(bp.id)">
          {{ bp.name }}
        </div>
      </div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel()">
          {{ cancelButtonText }}
        </v-btn>
        <v-btn color="primary" depressed @click="accept()">
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EcsBusinessProcessSelectionDialog',

  props: {
    title: {
      type: String,
      default: 'Business Process Selection'
    },
    message: {
      type: String,
      default: 'Please select a business process in order to continue.'
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel'
    },
    confirmButtonText: {
      type: String,
      default: 'Select'
    },
    customStyles: {
      type: Object,
      default: () => {
        return { maxWidth: '400px' };
      }
    }
  },

  data() {
    return {
      businessProcessId: '',
      dialog: false
    };
  },

  computed: {
    ...mapGetters('BUSINESS_PROCESSES', ['availableBusinessProcesses'])
  },

  created() {
    this.$root.$on('open-business-process-selection-dialog', this.open);
  },

  beforeDestroy() {
    this.$root.$off('open-business-process-selection-dialog', this.open);
  },

  methods: {
    open({ callback }) {
      this.dialog = true;
      this.$once('selected', selected => {
        callback(selected ? this.businessProcessId : false);
        this.businessProcessId = '';
      });
    },

    select(businessProcessId) {
      this.businessProcessId = businessProcessId;
      this.accept();
    },

    accept() {
      this.dialog = false;
      this.$emit('selected', true);
    },

    cancel() {
      this.dialog = false;
      this.$emit('selected', false);
    }
  }
};
</script>

<style scoped>
.bp-selection-dialog-message {
  font-size: 13px;
  word-break: break-word;
}

h3 {
  letter-spacing: 0.1em;
}

.bp-list-item {
  padding: 8px 16px;
  cursor: pointer;
}

.bp-list-item:hover {
  background-color: var(--v-surface-darken1);
}
</style>
